import * as React from "react";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { YODHA_COLORS } from "../constants/colours";

const Today = dayjs();

interface TileWithDateRangeProps {
  dateType: dayjs.ManipulateType;
  hasArrows: boolean;
  isCurrent: boolean;
  setIsCurrent: React.Dispatch<React.SetStateAction<boolean>>;
  centered: boolean;
  headerFontSize: number;
  dateRangeFontSize: number;
}

const TileWithDateRange = ({
  isCurrent,
  setIsCurrent,
  dateType,
}: TileWithDateRangeProps) => {
  const referenceDay = isCurrent ? Today : Today.subtract(1, dateType);
  // Sunday is 0 and Saturday is 6
  const mondayOfWeek =
    dayjs().format("dd") === "Su" ? referenceDay.day(-6) : referenceDay.day(1);
  const sundayOfWeek =
    dayjs().format("dd") === "Su" ? referenceDay.day(0) : referenceDay.day(7);
  const dateOfMonday = mondayOfWeek.date().toString();
  const dateOfSunday = sundayOfWeek.date().toString();

  const monthOfMonday = dayjs(mondayOfWeek).format("MMM").toString();

  const monthYearOfMonday = dayjs(mondayOfWeek).format("MMM YYYY").toString();
  const monthYearOfSunday = dayjs(sundayOfWeek).format("MMM YYYY").toString();
  // We show Monday's month if it is not the same as Sunday's month
  const showDayDate = dayjs(referenceDay).format("DD MMM YYYY").toString();
  const showMonthOfMonday =
    monthYearOfMonday !== monthYearOfSunday ? `${" " + monthOfMonday}` : "";

  const monthYear = referenceDay.format("MMM YYYY").toString();
  const year = referenceDay.format("YYYY").toString();

  return (
    <div className="flex flex-row justify-between items-center">
      {isCurrent ? (
        <FontAwesomeIcon
          icon={faAngleDoubleLeft}
          size={"2x"}
          className="cursor-pointer"
          color={YODHA_COLORS.greyAlt}
          onClick={() => setIsCurrent(false)}
        />
      ) : (
        <div className="w-8" />
      )}
      <div className="flex flex-row items-center">
        <p className="font-semibold text-lg uppercase">
          {isCurrent
            ? dateType === "day"
              ? "Today"
              : "This"
            : dateType === "day"
            ? "Yesterday"
            : "Last"}{" "}
          {dateType === "day" ? "" : dateType + "  "}
        </p>
        <p className="ml-5 font-semibold text-gray-400">
          {dateType === "day" && `${showDayDate}`}
          {dateType === "week" &&
            `${dateOfMonday}${showMonthOfMonday}-${dateOfSunday} ${monthYearOfSunday}`}
          {dateType === "month" && monthYear}
          {dateType === "year" && year}
        </p>
      </div>
      {!isCurrent ? (
        <FontAwesomeIcon
          icon={faAngleDoubleRight}
          size={"2x"}
          className="cursor-pointer"
          color={YODHA_COLORS.greyAlt}
          onClick={() => setIsCurrent(true)}
        />
      ) : (
        <div className="w-8" />
      )}
    </div>
  );
};

export default TileWithDateRange;
